import { emptyError } from "../../../Types/ServicesType/servicesType";
import api from "@services/apiList";
import instance from "@services/services";
const {reportsApi}=api
export const billWsieReportSearchService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.billwiseReportSearch,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}

export const billWsieReportSearchInternalCodeService = async (
  data: any,
): Promise<any> => {
  try {
    const result = await instance.post(
      reportsApi.billwiseReportSearchInternalCode,
      data,
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};
export const billWsieReportService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.billWiseReport,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}